import * as React from 'react';

import * as styles from './UndergroundMapModalFooter.css';

export const UndergroundMapModalFooter: React.FC = ({ children }) => <div className={styles['footer']}>{children}</div>;
